import { porkbunMetadata } from '@proton/payments/core/coupon-config/configs/porkbun';

import type { CouponConfig } from './interface';

export const porkbunConfig: CouponConfig = {
    ...porkbunMetadata,
};
